import EditIcon from '@mui/icons-material/Edit';
import { Dialog, DialogActions, DialogTitle } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { patchPolicies } from 'api/agent/policy/policyApi';
import theme from 'library/theme/theme';
import { useState } from 'react';

import * as S from './styles';

function MarkConfirmed({ data, setData, selectedCheckboxes }: any) {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const customStyle = { fontSize: '25px' };

  const mutation = useMutation(() => patchPolicies({ confirmed: true }, selectedCheckboxes), {
    onSuccess: () => {
      const updatedFilterData = [...data];

      updatedFilterData.forEach((item: any) => {
        if (selectedCheckboxes.includes(item.id)) {
          const index = item.policyStatus.findIndex((status: any) => status.key === 'confirmed');
          if (index !== -1) {
            item.policyStatus[index].value = true;
          }
        }
      });

      setData(updatedFilterData);
      setIsOpenModal(false);
    },
  });

  const handleFormSubmit = async () => {
    setIsOpenModal(true);
  };

  const handleCancelRemove = () => {
    setIsOpenModal(false);
  };

  const handleConfirmRemove = () => {
    mutation.mutate();
  };

  return (
    <S.Wrapper>
      <Dialog
        open={isOpenModal}
        onClose={handleCancelRemove}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Czy na pewno chcesz zmienić statusy na <S.SpanColor>potwierdzoną</S.SpanColor> ?
        </DialogTitle>
        <DialogActions>
          <S.ButtonWrapper>
            <S.ConfirmationButton color={theme.palette.primary.main} onClick={handleCancelRemove}>
              Nie
            </S.ConfirmationButton>
            <S.ConfirmationButton color="firebrick" onClick={handleConfirmRemove} autoFocus>
              Tak
            </S.ConfirmationButton>
          </S.ButtonWrapper>
        </DialogActions>
      </Dialog>
      <S.Button color="#038B00" onClick={handleFormSubmit} disabled={selectedCheckboxes.length === 0}>
        <EditIcon style={customStyle} />
        <S.Text>
          oznacz <S.Span>potwierdzoną</S.Span>
        </S.Text>
      </S.Button>
    </S.Wrapper>
  );
}

export default MarkConfirmed;
